module.exports = __webpack_public_path__ + "img/jane-stuart-woolsey.366deadd.png";